import {content} from 'constants/url';
import useLoad from 'components/hooks/useLoad';

function useLoadAttended(id: number) {
  return useLoad(content, 'iD_Content', {id});
}

export default useLoadAttended;
